<template>
  <span>{{Value}}
  </span>
</template>

<style scoped>

</style>

<script>
  import CellDate from "./cellDate.ts";
  export default CellDate;
</script>